import _get from "lodash/get";
import _orderBy from "lodash/orderBy";
import { useState, useRef, useEffect } from "react";
import { useDelayedRedirect } from "./useDelayedRedirect.js";
const useJoinBrandClub = (brand, handleJoinClub) => {
  const [joinedState, setJoinedState] = useState((brand == null ? void 0 : brand.isMember) ? "joined" : "not_join");
  const campaignRewards = _orderBy(_get(brand, ["campaignRewards"]), ["rewardAmount"], ["desc"]);
  const handleJoinError = (errorMessage) => {
    console.error("join club error: ", errorMessage);
    setJoinedState("not_join");
  };
  const handleJoin = async (e) => {
    var _a, _b;
    if (!(brand == null ? void 0 : brand.brandclubId)) {
      handleJoinError("brandclubId is not defined");
      return;
    }
    (_a = e == null ? void 0 : e.stopPropagation) == null ? void 0 : _a.call(e);
    (_b = e == null ? void 0 : e.preventDefault) == null ? void 0 : _b.call(e);
    try {
      setJoinedState("joining");
      const campaignId = _get(campaignRewards, ["0", "campaignId"], void 0);
      const res = await (handleJoinClub == null ? void 0 : handleJoinClub(brand.brandclubId, campaignId));
      if (res === "success") {
        setJoinedState("joined");
      } else {
        handleJoinError("Unknown error");
      }
    } catch (e2) {
      if (e2 instanceof Error) {
        handleJoinError(e2.message);
      } else {
        handleJoinError("Unknown error");
      }
    }
  };
  return {
    joinedState,
    handleJoin,
    campaignRewards
  };
};
const useJoinBrandClubWithRedirect = ({
  brand,
  handleJoinClub,
  link,
  delay = 500,
  navigate
}) => {
  const { joinedState, handleJoin, ...rest } = useJoinBrandClub(brand, handleJoinClub);
  const prevJoinedStateRef = useRef(joinedState);
  const delayedRedirect = useDelayedRedirect(navigate, delay);
  const brandId = brand == null ? void 0 : brand.brandId;
  useEffect(() => {
    if (brandId && prevJoinedStateRef.current === "joining" && joinedState === "joined") {
      delayedRedirect(link || `/joinclubsuccess/${brandId}`);
    }
    prevJoinedStateRef.current = joinedState;
  }, [joinedState, delayedRedirect, link, brandId]);
  return {
    joinedState,
    handleJoin,
    ...rest
  };
};
export {
  useJoinBrandClub,
  useJoinBrandClubWithRedirect
};
//# sourceMappingURL=useJoinBrandClub.js.map
